"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var react_dom_1 = require("react-dom");
var helpers_1 = require("../helpers");
var PopoverContextValue = /** @class */ (function () {
    function PopoverContextValue() {
        var _this = this;
        this.portalDomNode = null;
        this.getPortalDOMNode = function () {
            if (!_this.portalDomNode) {
                _this.portalDomNode = helpers_1.createPortalDomNode();
                if (!_this.portalDomNode) {
                    return null;
                }
                document.body.appendChild(_this.portalDomNode);
            }
            return _this.portalDomNode;
        };
    }
    return PopoverContextValue;
}());
exports.PopoverContextValue = PopoverContextValue;
exports.PopoverContext = react_2.createContext(new PopoverContextValue());
exports.PlacerContextConsumer = exports.PopoverContext.Consumer;
var PopoverContextProvider = /** @class */ (function (_super) {
    __extends(PopoverContextProvider, _super);
    function PopoverContextProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.portalDomNode = null;
        _this.getPortalDOMNode = function () {
            if (!_this.portalDomNode) {
                _this.portalDomNode = helpers_1.createPortalDomNode();
                if (!_this.portalDomNode) {
                    return null;
                }
                // eslint-disable-next-line react/no-find-dom-node
                var selfDOMNode = react_dom_1.findDOMNode(_this);
                if (selfDOMNode) {
                    if (selfDOMNode.parentNode && selfDOMNode.parentNode instanceof HTMLElement) {
                        var parentDOMNode_1 = selfDOMNode.parentNode;
                        var originalPosition_1 = parentDOMNode_1.style.position;
                        parentDOMNode_1.style.position = 'relative';
                        parentDOMNode_1.appendChild(_this.portalDomNode);
                        var originRemove_1 = _this.portalDomNode.remove.bind(_this.portalDomNode);
                        _this.portalDomNode.remove = function () {
                            parentDOMNode_1.style.position = originalPosition_1;
                            originRemove_1();
                        };
                        return _this.portalDomNode;
                    }
                }
                document.body.appendChild(_this.portalDomNode);
            }
            return _this.portalDomNode;
        };
        return _this;
    }
    PopoverContextProvider.prototype.render = function () {
        return react_1.default.createElement(exports.PopoverContext.Provider, { value: this }, this.props.children);
    };
    return PopoverContextProvider;
}(react_2.Component));
exports.PopoverContextProvider = PopoverContextProvider;
//# sourceMappingURL=PopoverContext.js.map